import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import './assets/style/common.less'
import './styles/index.less'
import initGlobalFilters from './utils/globel-filters'
import * as echarts from 'echarts'
import 'echarts-extension-amap'
// import VueAnimateNumber from 'vue-animate-number'
import dataV from '@jiaminghi/data-view'

import dayjs from 'dayjs'
import VueDeviceDetector from 'vue-device-detector'
var quarterOfYear = require('dayjs/plugin/quarterOfYear')
dayjs.extend(quarterOfYear)
Vue.prototype.dayjs = dayjs
// eslint-disable-next-line no-undef
Vue.prototype.$echarts = echarts
Vue.use(echarts)
Vue.use(dataV)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueDeviceDetector)
// Vue.use(VueAnimateNumber)

// initGlobalFilters
initGlobalFilters(Vue)
function noon() {}

const whiteList = ['/index', '/404', '/401', '/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  // console.log('beforeEach', from, to)
  store.commit('globalVariable/setHistory', to.path)
  if (whiteList.includes(to.path)) {
    next()
    return null
  }
  if (!store.getters.user) {
    const params = {
      selfAreaId: store.getters.globaleSelfAreaId
    }
    // 用户数据拉取
    store.dispatch('user/getInfo', params).then(res => {
      store.commit('globalVariable/selfAddress', res.data && res.data.areaName)
      // 用户权限拉取
      store.dispatch('user/getPermission', params).then(() => noon)
      // 用户区域范围拉取
      const areaParams = {
        userAreaId: res.data.areaId,
        selfAreaId: store.getters.globaleSelfAreaId,
        areaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('user/getUserArea2', areaParams).then(() => noon)
      const nationalParams = {
        selfAreaId: store.getters.globaleSelfAreaId
      }
      store.dispatch('globalVariable/getNationalArea', nationalParams).then(() => noon)
      next()
    }).catch(() => next())
  } else {
    next()
  }
})
Vue.mixin({
  data() {
    return {
      permission: true,
      inactivityTimer: '',
      lastActivityTime: Date.now() // 记录最后一次活动时间
    }
  },
  methods: {
    // val 值，key 第一级，type，
    // 一级检验：checkUserAuth(4,'id',null)
    // 二级校验：checkUserAuth(6, 'id', 'child', 'id', 28)
    // 优化结果：一级检验：checkUserAuth(4,null)
    // 优化结果：二级检验：checkUserAuth(4,28)
    checkUserAuth(val, itemVal) {
      if (itemVal === 'show') {
        return true
      }
      const key = 'id'
      const towkey = 'child'
      const threekey = 'id'
      let permission = false
      const curr = (this.user && this.user.auth) || []
      if (!curr || !curr.length) {
        return permission
      }
      if (itemVal || itemVal === 0) {
        const res = curr.find(it => it[key] === val) && curr.find(it => it[key] === val)[towkey]
          ? curr.find(it => it[key] === val)[towkey].filter(it => it[threekey] === itemVal)
          : []
        if (res.length > 0) {
          permission = true
        }
      } else {
        const res = curr.filter(it => it[key] === val)
        if (res.length > 0) {
          permission = true
        }
      }
      return permission
    },
    getLoginDevice() {
      const device = this.$device
      let deviceName = ''
      if (device.android) {
        deviceName = 'Android设备'
      } else if (device.androidPhone) {
        deviceName = 'Android手机'
      } else if (device.dingding) {
        deviceName = '钉钉应用'
      } else if (device.iOS) {
        deviceName = 'iOS设备'
      } else if (device.ipad) {
        deviceName = 'iPad'
      } else if (device.iphone) {
        deviceName = 'iPhone'
      } else if (device.iphoneX) {
        deviceName = 'iPhoneX'
      } else if (device.ipod) {
        deviceName = 'iPod'
      } else if (device.mobile) {
        deviceName = '移动设备'
      } else if (device.wechat) {
        deviceName = '微信应用'
      } else if (device.wechatMiniApp) {
        deviceName = '微信小程序'
      } else {
        deviceName = 'Windows设备'
      }
      return deviceName
    },
    resetTimer() {
      clearTimeout(this.inactivityTimer)
      const timeoutDuration = 30 * 60 * 1000 // 30分钟
      const elapsedTime = Date.now() - this.lastActivityTime
      const remainingTime = timeoutDuration - elapsedTime
      this.inactivityTimer = setTimeout(() => {
        // 执行注销操作或者跳转到登录页面的代码
        router.push('/login')
      }, remainingTime)
    },
    updateActivityTime() {
      this.lastActivityTime = Date.now()
    }
  },
  created() {
    document.title = '盘锦市共享单车监管平台'
    this.resetTimer()

    // 监听用户活动事件来更新最后活动时间并重置定时器
    document.addEventListener('mousemove', () => {
      this.updateActivityTime()
      this.resetTimer()
    })
    document.addEventListener('keydown', () => {
      this.updateActivityTime()
      this.resetTimer()
    })
  },
  beforeDestroy() {
    // 在组件销毁前清除定时器
    clearTimeout(this.inactivityTimer)
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
